import { GliderApi } from '@vista/omnichannel-components-ui/lib/src/lib/subcomponents/carousel/types/glider'

interface IGliderElement extends HTMLDivElement {
    _glider?: GliderApi
}

/*
 * Function is used to recalculate width of glider for DateShowtimePicker due to filter changes. Known OCC issue
 * that must be resolved. This of this issue is here.
 * https://teams.microsoft.com/l/message/19:d0e22601086c4b7292f29a9b4284cd27@thread.skype/1677087272298?tenantId=9a2a7202-e5e0-4d87-8961-875023f85cc5&groupId=2d5e50ed-b2a2-4f33-be4a-b0b26d0b7cc2&parentMessageId=1677087272298&teamName=Dev%20Support&channelName=Omni-Channel%20Components&createdTime=1677087272298&allowXTenantAccess=false
 * TODO: Once bug is resolved, remove hack.
 * */
export const refreshDateShowtimePickerGlider = (dateShowtimePickerContainer: HTMLDivElement) => {
    const gliderElement: IGliderElement | null =
        dateShowtimePickerContainer.querySelector('.v-carousel__viewport.glider')

    if (gliderElement && gliderElement._glider) {
        const glider = gliderElement._glider
        glider.refresh()
    }
}
